export default __webpack_public_path__ + "static/media/disabled-vod-icon.6717099f.svg";